import { RequesterTypology } from './HelpPageContent.types';

export const REQUESTER_TYPOLOGIES = [
  {
    label: 'iHaveAHouseToRent',
    value: RequesterTypology.PotentialLandlord,
  },
  {
    label: 'iAlreadyRentAHouseWithZappyrent',
    value: RequesterTypology.Landlord,
  },
  {
    label: 'iLookForAHouseToRent',
    value: RequesterTypology.PotentialTenant,
  },
  {
    label: 'iAlreadyRentWithZappyrent',
    value: RequesterTypology.Tenant,
  },
];

export const CATEGORIES = {
  contracts: [
    'renewal',
    'extension',
    'notice',
    'registration',
    'contractSigning',
    'other',
  ],
  creditCheck: ['documentSubmission', 'creditCheckOutcome', 'other'],
  myBooking: ['checkIn', 'checkOut', 'bookingStatusUpdate', 'other'],
  maintainance: [],
  payments: [
    'depositRefund',
    'rentPayment',
    'utilities',
    'failedPayment',
    'paymentReceipt',
    'refunds',
    'other',
  ],
  moreInfoOnProperty: ['generalInformation', 'visits', 'other'],
  other: [],
};
